<div class="offer-detail-box">
    <div class="offer-detail-box__label">
        <span class="offer-detail-box__label__icon material-icons">check</span>
        <span class="offer-detail-box__label__name">
        {{ label }}<ng-container *ngIf="additionalInfo">:</ng-container>
    </span>
    </div>

    <span *ngIf="additionalInfo"
         class="offer-detail-box__value">
            <ng-container *ngIf="isValueAmount; else notAmount" >
                {{additionalInfo | separator}} {{'OFFER_SECTION.SHARED.currencyShortcut' | translate}}
            </ng-container>
            <ng-template #notAmount>
                {{additionalInfo}}
            </ng-template>
    </span>
</div>
